import React, { useState } from 'react';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Traceability from "../Traceability";
import IconButton from '@material-ui/core/IconButton';
import Message from "../../Components/Message";
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import withStyles from "@material-ui/core/styles/withStyles";
import TraceabilityUtils from "../TraceabilityUtils";
import {StylesContext} from "../../App";

const EMPTY_MESSAGE = {
  open: false,
  message: '',
  status: 'info',
};

const CssTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '0px solid white',
        backgroundColor: 'rgba(0, 0, 0, 0.029)',
      },
    },
  },
})(TextField);

export default function SupplierForm(props) {
  const classes = React.useContext(StylesContext);
  const utils = new TraceabilityUtils();

  const [supplier, setSupplier] = useState(props.supplier ? props.supplier : {});
  const [isBlocking, setIsBlocking] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [message, setMessage] = useState({ ...EMPTY_MESSAGE });
  const [submitting, setSubmitting] = useState(false);

  function validateForm() {
    setSubmitAttempted(true);

    /*if (!supplier.email || !(/.+@.+\.[a-zA-Z]{2,}/gm).test(supplier.email)) {
      setMessage({ open: true, message: 'Please enter a valid email.', status: 'error' });
      return false;
    }*/

    if (!supplier.name || !(/^[A-Za-z][A-Za-z\s]*$/).test(supplier.name)) {
      setMessage({ open: true, message: 'Please enter the valid Supplier Name.', status: 'error' });
      return false;
    }

    if (!supplier.supplier_id || !(/^[a-zA-Z0-9]+$/).test(supplier.supplier_id)) {
      setMessage({ open: true, message: 'Please enter the valid Supplier Id.', status: 'error' });
      return false;
    }

    const supplier_id = supplier.supplier_id;
    const foundKey = Object.keys(props.supplierIdsDict).find(key => props.supplierIdsDict[key] == supplier_id);
    if (foundKey) {
      if (supplier.id != foundKey) {
        setMessage({ open: true, message: 'Supplier id already exists Please use another.', status: 'error' });
        return false;
      }
    }

    if (!supplier.contact_person || !(/^[A-Za-z][A-Za-z\s]*$/).test(supplier.contact_person)) {
      setMessage({ open: true, message: 'Please enter the valid Supplier Contact Person Name.', status: 'error' });
      return false;
    }

    if (!supplier.phone_number || !(/^(\+\d{1}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/g).test(supplier.phone_number)) {
      setMessage({ open: true, message: 'Phone number invalid. Must include Country Code (often 1) + Area Code', status: 'error' });
      return false;
    }

    return true;
  }


  function handleSubmit(saveAndContinue) {
    setSubmitting(true);
    setSubmitAttempted(true);
    if (!validateForm()) {
      setSubmitting(false);
      return;
    }

    let supplierObject = { ...supplier };

    if (props.setShouldClose) {
      props.setShouldClose(true);
    }

    let organization = JSON.parse(localStorage.getItem("organization"))
    supplierObject.organization = organization.pk;
    supplierObject.traceability = props.activeTraceability.pk;
    // const api = new Traceability().getSupplierAPI();
    const api = new Traceability().getFSuppliersAPI();

    if (supplierObject.id) {
      // api.updateSupplier(supplierObject)
      api.updateFSuppliers(supplierObject)
      .then(response => {
        if (props.setShouldClose) {
          props.setShouldClose(true);
        }
        setSupplier({...response.data, type: 'Supplier'});
        props.setSupplierIdsDict({...props.supplierIdsDict,[response.data.id]:response.data.supplier_id});
        setSubmitAttempted(false);
        if (props.onSave) {
          props.onSave(response, {...response.data, type: 'Supplier'}, saveAndContinue);
        }
        setMessage({ open: true, message: 'Saved Successfully', status: 'success' });
        setSubmitting(false);
      }).catch(error => {
        setMessage({ open: true, message: 'Server Error: ' + utils.formatError(error), status: 'error' });
        setSubmitting(false);
        //console.log('Error Response: ' + JSON.stringify(error));
      });
    }
    else {
      // api.createSupplier(supplierObject)
      api.createFSuppliers(supplierObject)
      .then(response => {
        if (props.setShouldClose) {
          props.setShouldClose(true);
        }
        setSupplier({...response.data, type: 'Supplier'});
        props.setSupplierIdsDict({...props.supplierIdsDict,[response.data.id]:response.data.supplier_id})
        setSubmitAttempted(false);
        if (props.onSave) {
          props.onSave(response, {...response.data, type: 'Supplier'}, saveAndContinue);
        }
        setMessage({ open: true, message: 'Saved Successfully', status: 'success' });
        setSubmitting(false);
      }).catch(error => {
        setMessage({ open: true, message: 'Server Error: ' + utils.formatError(error), status: 'error' });
        setSubmitting(false);
        //console.log('Error Response: ' + JSON.stringify(error));
      });
    }
  }

  function handlePhoneFieldChange(event) {
    if (props.setShouldClose) {
      props.setShouldClose(false);
    }

    const property = event.target.name;
    let phoneString = event.target.value;

    if(phoneString[0] && phoneString[0] != '+' ) {
      phoneString = '+' + phoneString;
    } 

    setSupplier({ ...supplier, [property]: phoneString });

  }

  function handleTextFieldChange(event) {
    setIsBlocking(true);
    if (props.setShouldClose) {
      props.setShouldClose(false);
    }
    const property = event.target.name;
    const value = event.target.value;

    setSupplier({ ...supplier, [property]: value });
  }

  function cancel() {
    setSupplier(props.supplier ? props.supplier : {});

    setIsBlocking(true);
    if (props.setShouldClose) {
      props.setShouldClose(false);
    }
  }

  function handleDelete() {
    let supplierName = supplier.company || supplier.supplier_id || 'this supplier';

    if(!window.confirm('Are you sure you want to delete ' + supplierName + '?')){
      return;
    }

    if(!supplier || !supplier.id) {
      props.closeModal ? props.closeModal() : cancel();
    }
    //let pkToDelete = customer.pk;
    // const suppAPI = new Traceability().getSupplierAPI();
    const suppAPI = new Traceability().getFSuppliersAPI();

    suppAPI.deleteFSuppliers(supplier.id).then(response => {
      
      if (props.onDelete) {
        props.onDelete(response, {id: supplier.id, type: 'Supplier', soft_delete: true}, true);
      }
      const { [supplier.id]: deletedSupplier, ...updatedSupplierIdsDict } = props.supplierIdsDict;
      props.setSupplierIdsDict(updatedSupplierIdsDict);
      setMessage({ open: true, message: 'Deleted Successfully', status: 'success' });
      props.closeModal();
    }).catch(error => {
      setMessage({ open: true, message: 'Server Error: ' + utils.formatError(error), status: 'error' });
      //console.log('Error Response: ' + JSON.stringify(error));
    });
  }
  
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} className={classes.generalContainerGridHead}>
        <Grid item xs={11}>
          <Typography variant="h6" noWrap className={classes.generalFormHeaderTypography}>
            Supplier Form
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <IconButton style={{ float: 'right' }} onClick={props.closeModal ? props.closeModal : cancel}>
            <CancelIcon style={{ float: 'right' }} />
          </IconButton>
        </Grid>
      </Grid>


      
      <Grid container spacing={3} className={classes.generalContainerGridBody} style={{marginTop: '16px'}}>

        <Grid item xs={12}>
          <Typography variant="h5" noWrap className={classes.generalFormSubsectionHeader}>
            Supplier Details
          </Typography>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={0} square className={classes.generalFormPaperContainerApprovedInfo}>
            <Grid container spacing={3} className={classes.generalContainerGrid}>
              <Grid item xs={8}>
                <Typography className={classes.generalFormTypographyHeader}>
                  Supplier Name
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="Supplier Name"
                  className={classes.generalFormTextField}
                  name="name"
                  variant="outlined"
                  value={supplier.name}
                  error={submitAttempted && !supplier.name}
                  onChange={handleTextFieldChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography className={classes.generalFormTypographyHeader}>
                  Supplier ID
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="Unique Identifier"
                  className={classes.generalFormTextField}
                  name="supplier_id"
                  variant="outlined"
                  value={supplier.supplier_id}
                  //error={submitAttempted && !supplier.supplier_id}
                  onChange={handleTextFieldChange}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h5" noWrap className={classes.generalFormSubsectionHeader}>
            Primary Contact Information
          </Typography>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={0} square className={classes.generalFormPaperContainerApprovedInfo} style={{marginBottom: '16px'}}>
            <Grid container spacing={3} className={classes.generalContainerGrid}>
              {/* <Grid item xs={6}>
                <Typography className={classes.generalFormTypographyHeader}>
                  Contact Name
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="First Name"
                  className={classes.generalFormTextField}
                  name="contact_first_name"
                  variant="outlined"
                  value={supplier.contact_first_name}
                  //error={submitAttempted && !supplier.contact_first_name}
                  onChange={handleTextFieldChange}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography style={{color: 'rgba(0, 0, 0, 0)'}} className={classes.generalFormTypographyHeader}>
                  .
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="Last Name"
                  className={classes.generalFormTextField}
                  name="contact_last_name"
                  variant="outlined"
                  value={supplier.contact_last_name}
                  //error={submitAttempted && !supplier.contact_last_name}
                  onChange={handleTextFieldChange}
                />
              </Grid> */}
              <Grid item xs={6}>
                <Typography className={classes.generalFormTypographyHeader}>
                  Contact Name
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="Name"
                  className={classes.generalFormTextField}
                  name="contact_person"
                  variant="outlined"
                  value={supplier.contact_person}
                  //error={submitAttempted && !supplier.contact_first_name}
                  onChange={handleTextFieldChange}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className={classes.generalFormTypographyHeader}>
                  Contact Email
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="example@email.com"
                  className={classes.generalFormTextField}
                  name="email"
                  variant="outlined"
                  value={supplier.email || ''}
                  //error={submitAttempted && (!supplier.email || !(/.+@.+\.[a-zA-Z]{2,}/gm).test(supplier.email))}
                  onChange={handleTextFieldChange}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.generalFormTypographyHeader}>
                  Contact Phone
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="12223334567"
                  className={classes.generalFormTextField}
                  name="phone_number"
                  variant="outlined"
                  //defaultValue="+"
                  value={supplier.phone_number}
                  //error={submitAttempted && !(/^(\+\d{1}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/g).test(supplier.phone_number)}
                  onChange={handleTextFieldChange}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className={classes.generalFormTypographyHeader}>
                  Address
                </Typography>
                <CssTextField
                  fullWidth
                  placeholder="Address"
                  className={classes.generalFormTextField}
                  name="address"
                  multiline
                  rows={1}
                  variant="outlined"
                  value={supplier.address}
                  //error={submitAttempted && !supplier.address}
                  onChange={handleTextFieldChange}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

      </Grid>

      <Paper elevation={0} square className={classes.generalFormPaperStickyFooterApprovedInfo}>
        <Grid container spacing={3} className={classes.generalContainerGridFoot}>
          <Grid item container xs={12} alignItems="center" justify="flex-end">
            {supplier.id &&
              <Button
                variant="outlined"
                startIcon={<DeleteIcon />}
                style={{ marginLeft: "8px" }}
                onClick={() => {handleDelete()} }
                disabled={submitting}
              >
                Delete
              </Button>
            }
            <Button
              color="secondary"
              style={{ marginLeft: "8px" }}
              onClick={props.closeModal ? props.closeModal : cancel}
              disabled={submitting}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: "8px" }}
              onClick={() => { handleSubmit(false) }}
              disabled={submitting}
            >
              Save Changes
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: "8px" }}
              onClick={() => { handleSubmit(true) }}
              disabled={submitting}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Message
        open={message.open}
        message={message.message}
        severity={message.status}
        vertical="bottom"
        horizontal="left"
        handleClose={() => { setMessage({ ...message, open: false }) }}
      />

    </form>
  )
}

SupplierForm.propTypes = {
  supplier: PropTypes.object,
  handleSubmit: PropTypes.func,
  user: PropTypes.object.isRequired,
  activeTraceability: PropTypes.object.isRequired,
  setShouldClose: PropTypes.func,
  onSave: PropTypes.func,
  closeModal: PropTypes.func,
  cancel: PropTypes.func,
}